import { experience } from '../mock';
import tpLogo from '../assets/logos/tp-blackpink.png';
import jioLogo from '../assets/logos/jio.webp';

const LOGO_MAP = {
  'TATA PLAY': tpLogo,
  'RELIANCE JIO': jioLogo,
};

export default function Experience() {
  return (
    <section id="experience" className="relative py-[50px]" style={{ background: 'linear-gradient(180deg, transparent 0%, rgba(237,232,220,0.55) 40%, transparent 100%)' }}>
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="mb-12 md:mb-14">
          <p className="reveal font-hand text-[26px] md:text-[30px] mb-2" style={{ color: 'var(--terracotta-deep)' }}>
            where I&apos;ve worked
          </p>
          <h2 className="reveal reveal-delay-1 font-display text-[34px] md:text-[46px] leading-tight" style={{ color: 'var(--ink)' }}>
            Building products used by <em className="italic" style={{ color: 'var(--sage)' }}>millions</em> across India
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-5 md:gap-6">
          {experience.map((e, i) => (
            <ExperienceCard key={e.company} e={e} idx={i} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ExperienceCard({ e, idx }) {
  return (
    <div
      className={`reveal reveal-delay-${idx + 1} relative group rounded-[20px] p-7 md:p-9 transition-all duration-500`}
      style={{
        background: 'var(--surface)',
        border: '1px solid var(--border)',
      }}
      onMouseEnter={(e) => (e.currentTarget.style.boxShadow = '0 18px 40px -18px rgba(90,60,30,0.22)')}
      onMouseLeave={(e) => (e.currentTarget.style.boxShadow = 'none')}
    >
      <span
        className="absolute left-7 right-7 top-0 h-[2px] rounded-full origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500"
        style={{ background: 'linear-gradient(90deg, #C4622D, #D4A853)' }}
      />
      <div className="flex items-center justify-between">
        <p className="text-[11px] tracking-[0.22em] uppercase" style={{ color: 'var(--sage)' }}>
          {e.period}
        </p>
        <span className="w-2 h-2 rounded-full" style={{ background: 'var(--terracotta)' }} />
      </div>
      <div className="mt-3 mb-2 h-[68px] md:h-[76px] flex items-center">
        {LOGO_MAP[e.company] ? (
          <img
            src={LOGO_MAP[e.company]}
            alt={e.company}
            className="h-full w-auto object-contain"
            data-testid={`experience-logo-${e.company.toLowerCase().replace(/\s+/g, '-')}`}
          />
        ) : (
          <h3 className="font-display text-[30px] md:text-[36px]" style={{ color: 'var(--ink)' }}>
            {e.company}
          </h3>
        )}
      </div>
      <p className="text-[15.5px]" style={{ color: 'var(--ink-soft)' }}>
        {e.role}
      </p>
      <p className="text-[13.5px] mt-5" style={{ color: 'var(--sage)' }}>
        {e.product}
      </p>
    </div>
  );
}
